import { responsiveVanillaSelector, forumSelector } from '../selectors';
import type { Site } from '../Site';

export const TomsHardware: Site = {
  id: 'tomshardware',
  logo: 'svg/tomshardware.svg',
  label: "Tom's Hardware",
  analyticsName: 'tomshardware',
  hostname: 'tomshardware.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, ${forumSelector}`,
};
